/**
 * 閲覧履歴保存
 */

// import global variables.
import {LOCATION, getStorageItem, setStorageItem} from '../utils/global';

/**
 * デフォルト実行処理
 * @return {Void}
 */
export default () => {
    const locationPathArray = LOCATION.path.replace(/^\/|\/$/g, '').split('/');

    // productディレクトリは以下だった場合のみ実行する
    if (locationPathArray[0] !== 'product') {
        return;
    }

    const history = JSON.parse(getStorageItem('history')) || [];
    const historyIds = history.map((obj) => obj.id);
    const [, productId] = locationPathArray;
    const sameProductIdIndex = historyIds.indexOf(productId);

    // すでに履歴にidが存在する場合、そのidを削除する
    if (sameProductIdIndex !== -1) {
        history.splice(sameProductIdIndex, 1);
    }

    // 配列の先頭に追加
    history.unshift({
        id: productId,
        time: Date.now()
    });

    // ローカルストレージを更新
    setStorageItem('history', JSON.stringify(history.slice(0, 20)));
};
